import React, { useState, useEffect } from 'react'
import loginBackground from '../../../assets/images/login-background'
import logo from '../../../assets/images/rio-claro-logo-colorida.svg'
import LoginFooter from '../../components/layout/Footer/LoginFooter'
import CustomPasswordInput from '../../components/ui/inputs/CustomPasswordInput'
import CustomButton from '../../components/ui/buttons/CustomButton'
import { fetchWithCsrf } from '../../utils/fetchWithCsrf'
import { snakecaseKeys } from '../../utils/snakecaseKeys'
import { useToast } from '../../components/ui/toast/ToastContext'

const ResetPassword = () => {
  const [token, setToken] = useState('')
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [loading, setLoading] = useState(false)
  const { addToast } = useToast()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const tokenFromUrl = params.get('reset_password_token')
    if (tokenFromUrl) {
      setToken(tokenFromUrl)
    } else {
      addToast({ type: 'error', message: 'Token de redefinição inválido ou ausente.' })
    }
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    if (!token) {
      addToast({ type: 'error', message: 'Token de redefinição ausente.' })
      setLoading(false)
      return
    }

    if (password !== passwordConfirmation) {
      addToast({ type: 'error', message: 'As senhas não coincidem.' })
      setLoading(false)
      return
    }

    const payload = snakecaseKeys({
      admin: {
        resetPasswordToken: token,
        password,
        passwordConfirmation
      }
    })

    try {
      const res = await fetchWithCsrf('/admins/password', {
        method: 'PUT',
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      })

      if (res.ok) {
        addToast({ type: 'success', message: 'Senha redefinida com sucesso!' })
        setTimeout(() => {
          window.location.replace('/admins/sign_in')
        }, 300)
      } else {
        const contentType = res.headers.get('Content-Type') || ''
        if (contentType.includes('application/json')) {
          const json = await res.json()
          addToast({ type: 'error', message: json.error || 'Erro ao redefinir senha.' })
        } else {
          addToast({ type: 'error', message: 'Erro inesperado do servidor (HTML retornado).' })
        }
      }
    } catch (err) {
      console.error(err)
      addToast({ type: 'error', message: 'Erro inesperado. Tente novamente.' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${loginBackground})` }}
    >
      <div className="bg-white px-20 py-10 rounded-custom20 w-full max-w-2xl shadow-xl text-blueDarker font-jost">
        <div className="flex items-center justify-center text-center mb-8">
          <img src={logo} alt="Rio Claro Investimentos" className="w-custom240" />
        </div>

        <div className="mb-6 text-center">
          <p className="text-2xl font-semibold">Redefinir senha</p>
          <p className="text-base font-normal pt-2">
            Insira sua nova senha nos campos abaixo.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" noValidate>
          <CustomPasswordInput
            label="Nova senha"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            required
          />
          <CustomPasswordInput
            label="Confirme a nova senha"
            name="password_confirmation"
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            disabled={loading}
            required
          />
          <div className="flex justify-center mt-3">
            <CustomButton disabled={loading} type="submit">
              REDEFINIR SENHA
            </CustomButton>
          </div>
        </form>

        <div className="flex items-center justify-center text-center mb-5 mt-6">
          <span>
            Não possui credenciais?{' '}
            <a href="mailto:ola@humanoide.co" className="font-semibold hover:opacity-80 underline">
              Entre em contato conosco
            </a>.
          </span>
        </div>
      </div>
      <LoginFooter />
    </div>
  )
}

export default ResetPassword
